import Vue from 'vue';
import Vuex from 'vuex';
import FoodService from '@/services/FoodService';
import TagService from '@/services/TagService';
import DietService from '@/services/DietService';
import MealService from '@/services/MealService';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    meals: [],
    dayMeals: [],
    dayFoods: [],
    diets: [],
    streams: [],
    mealIngredients: [],
    tags: {},
    mealTags: {},
    nutrients: {},
    targets: {},
    user: {},
    mealComponents: []
  },
  getters: {
    getMealFood(state) {
      return state.mealIngredients;
    },
    getTags(state) {
      return state.tags;
    },
    getMealTags(state) {
      return state.mealTags;
    },
    getNutrients(state) {
      return state.nutrients;
    },
    getMeals(state) {
      return state.meals;
    },
    getTargets(state) {
      return state.targets;
    },
    getUser(state) {
      return state.user;
    },
    getDiets(state) {
      return state.diets;
    },
    getStreams(state) {
      return state.streams;
    },
    getMealComponents(state) {
      return state.mealComponents;
    },
    getDayMeals(state) {
      return state.dayMeals;
    },
    getDayFoods(state) {
      return state.dayFoods;
    }
  },
  mutations: {
    ADD_FOOD(state, food) {
      // @ts-ignore
      state.mealIngredients = [...state.mealIngredients, food];
    },
    ADD_FOODS(state, foods) {
      // @ts-ignore
      state.mealIngredients = [...state.mealIngredients, ...foods];
    },
    REMOVE_FOOD(state, index) {
      state.mealIngredients.splice(index, 1);
    },
    UPDATE_FOOD(state, {index, food}) {
      // @ts-ignore
      state.mealIngredients[index] = food;
      state.mealIngredients = [...state.mealIngredients];
    },
    SET_TAGS(state, tags) {
      state.tags = tags;
    },
    SET_MEAL_TAGS(state, tags) {
      state.mealTags = tags;
    },
    SET_NUTRIENTS(state, nutrients) {
      state.nutrients = nutrients;
    },
    SET_MEALS(state, meals) {
      state.meals = meals;
    },
    SET_DIETS(state, diets) {
      state.diets = diets;
    },
    SET_STREAMS(state, streams) {
      state.streams = streams;
    },
    ADD_DIET(state, diet) {
      // @ts-ignore
      state.diets = [...state.diets, diet];
    },
    ADD_MEAL(state, meal) {
      // @ts-ignore
      state.meals = [...state.meals, meal];
    },
    DELETE_MEAL(state, id) {
      // @ts-ignore
      state.meals = state.meals.filter((item) => item.id !== id);
    },
    DELETE_USER(state, email) {
        // @ts-ignore
        state.users = state.users.filter((item) => item.email !== email);
    },
    ADD_TAGS(state, tags) {
      // @ts-ignore
      state.tags = [...state.tags, ...tags];
    },
    ADD_MEAL_TAGS(state, tags) {
      // @ts-ignore
      state.mealTags = [...state.mealTags, ...tags];
    },
    REMOVE_TAG(state, name) {
      // @ts-ignore
      state.tags = state.tags.filter((item: object) => item.name !== name);
    },
    REMOVE_MEAL_TAG(state, name) {
      // @ts-ignore
      state.mealTags = state.mealTags.filter((item: object) => item.name !== name);
    },
    UPDATE_MEAL(state, meal) {
      // @ts-ignore
      const index = state.meals.findIndex((item) => item.id === meal.id);
      // @ts-ignore
      state.meals[index] = meal;
      state.meals = [...state.meals];
    },
    UPDATE_DIET(state, diet) {
      // @ts-ignore
      const index = state.diets.findIndex((item) => item.id === diet.id);
      // @ts-ignore
      state.diets[index] = diet;
      state.diets = [...state.diets];
    },
    REMOVE_DIET(state, id) {
      // @ts-ignore
      state.diets = state.diets.filter((item) => item.id !== id);
    },
    UPDATE_COMPONENT(state, diet) {
      // @ts-ignore
      const index = state.diets.findIndex((item) => item.id === diet.id);
      // @ts-ignore
      state.diets[index] = diet;
      state.diets = [...state.diets];
    },
    REMOVE_COMPONENT(state, id) {
      // @ts-ignore
      state.diets = state.diets.filter((item) => item.id !== id);
    },
    SET_COMPONENTS(state, mealComponents) {
      // @ts-ignore
      state.mealComponents = mealComponents;
    },
    DELETE_COMPONENT(state, id) {
      // @ts-ignore
      state.mealComponents = state.mealComponents.filter((item) => item.id !== id);
    },
    SET_DAY_MEALS(state, dayMeals) {
      // @ts-ignore
      state.dayMeals = dayMeals;
    },
    SET_DAY_FOODS(state, dayFoods) {
      // @ts-ignore
      state.dayFoods = dayFoods;
    },
    ADD_DAY_FOODS(state, dayFoods) {
      // @ts-ignore
      state.dayFoods = [...state.dayFoods, ...dayFoods];
    },
    SET_TARGETS(state, {targets, diet}) {
      // @ts-ignore
      Vue.set(state.targets, diet, targets);
      // @ts-ignore
      state.targets = {...state.targets};
    },
    UPDATE_USER(state, user) {
      state.user = user;
    },
    UPDATE_COMPONENT_FOOD(state, {food, componentId}) {
      // @ts-ignore
      const component = state.mealComponents.find((item) => item.id === parseInt(componentId, 10));
      // @ts-ignore
      const foodIndex = component.foods.findIndex((item) => item.foodid === food.foodid);
      // @ts-ignore
      component.foods[foodIndex] = food;
      state.mealComponents = [...state.mealComponents];
    },
    UPDATE_DAY_FOOD(state, food) {
      // @ts-ignore
      const index = state.dayFoods.findIndex((item) =>
      // @ts-ignore
        item.foodid === food.foodid && item.component === food.component);
      // @ts-ignore
      state.dayFoods[index] = food;
      state.dayFoods = [...state.dayFoods];
    }
  },
  actions: {
      async getIngredientInfo({commit}, id) {
        await FoodService.getIngredientInfo(id);
      },
      addIngredientToMeal({commit}, food) {
        commit('ADD_FOOD', food);
      },
      addIngredientsToMeal({commit}, foods) {
        commit('ADD_FOODS', foods);
      },
      deleteFoodFromMeal({commit}, foodIndex) {
          commit('REMOVE_FOOD', foodIndex);
      },
      updateFood({commit}, {index, food}) {
          commit('UPDATE_FOOD', {index, food});
      },
      async getTags({commit}) {
        const response = await FoodService.getFoodTags();
        const tags = response.data;
        commit('SET_TAGS', tags);
      },
      async getDiets({commit}) {
        const { data } = await DietService.getDiets();
        commit('SET_DIETS', data);
      },
      async getStreams({commit}) {
        const { data } = await MealService.getMealStreams();
        commit('SET_STREAMS', data);
      },
      async getMealTags({commit}) {
        const response = await TagService.getMealTags();
        const tags = response.data;
        commit('SET_MEAL_TAGS', tags);
      },
      async getNutrients({commit}) {
        const response = await FoodService.getNutrients();
        const nutrientsArray = response.data;
        const nutrientsObject: any = {};
        for (const nutrient of nutrientsArray) {
          nutrientsObject[nutrient.nutrientnameid] = nutrient;
        }
        commit('SET_NUTRIENTS', nutrientsObject);
      },
      async getNutrientTargets({commit}, diet) {
        const response = await FoodService.getNutrientTargets(diet);
        commit('SET_TARGETS', {targets: response.data, diet});
      },
      setMeals({commit}, meals) {
        commit('SET_MEALS', meals);
      },
      addMeal({commit}, meal) {
        commit('ADD_MEAL', meal);
      },
      updateMeal({commit}, meal) {
        commit('UPDATE_MEAL', meal);
      },
      updateDiet({commit}, diet) {
        commit('UPDATE_DIET', diet);
      },
      addDiet({commit}, diet) {
        commit('ADD_DIET', diet);
      },
      removeDiet({commit}, id) {
        commit('REMOVE_DIET', id);
      },
      updateComponent({commit}, component) {
        commit('UPDATE_COMPONENT', component);
      },
      setComponents({commit}, mealComponents) {
        commit('SET_COMPONENTS', mealComponents);
      },
      deleteComponent({commit}, id) {
        commit('DELETE_COMPONENT', id);
      },
      removeComponent({commit}, id) {
        commit('REMOVE_COMPONENT', id);
      },
      deleteMeal({commit}, id) {
        commit('DELETE_MEAL', id);
      },
      deleteUser({commit}, email) {
          commit('DELETE_USER', email);
      },
      addTags({commit}, tags) {
        commit('ADD_TAGS', tags);
      },
      addMealTags({commit}, tags) {
        commit('ADD_MEAL_TAGS', tags);
      },
      removeTag({commit}, tagname) {
        commit('REMOVE_TAG', tagname);
      },
      removeMealTag({commit}, tagname) {
        commit('REMOVE_MEAL_TAG', tagname);
      },
      setUser({commit}, user) {
        commit('UPDATE_USER', user);
      },
      setDayMeals({commit}, dayMeals) {
        commit('SET_DAY_MEALS', dayMeals);
      },
      setDayFoods({commit}, dayFoods) {
        commit('SET_DAY_FOODS', dayFoods);
      },
      addDayFoods({commit}, dayFoods) {
        commit('ADD_DAY_FOODS', dayFoods);
      },
      updateDayFood({commit}, food) {
        commit('UPDATE_DAY_FOOD', food);
      },
      updateComponentFood({commit}, {food, componentId}) {
        commit('UPDATE_COMPONENT_FOOD', {food, componentId});
      },
      async initData({dispatch}) {
        // @ts-ignore
        await Promise.all([dispatch('getTags'),
          dispatch('getDiets'),
          dispatch('getStreams'),
          dispatch('getMealTags'),
          dispatch('getNutrients'),
          dispatch('getNutrientTargets', '1'),
          dispatch('setUser', JSON.parse((localStorage ? localStorage.getItem('user') : null) || 'null'))]);
      }
  },
});
